import { useCallback, useEffect, useState } from "react";
import { shallow } from "zustand/shallow";
import CardDashboard from "../../components/cardDashboard";
import { useHeaderStore } from "../../../../store/header.store";

import style from "./Dashboard.module.css";
import styleForm from "../../../../common/theme/styles/form.module.css";

import ProgressBar from "../../../../common/UI/ProgressBar";
import DateInput from "../../../../common/UI/Inputs/InputDate";
import { GetInquiryAveragesAnalyticsService, IParamasGetInquiry } from "../../services/dashboard/getInquiryAveragesAnalytics.service";
import useFormattedDate from "../../../../common/hooks/useFormattedDate";
import { InquiryAveragesAnalyticsResponseDto } from "../../dtos/dashboard.dto";

import ChartComponent from "../../components/chart";
import { GetInquiryAnalyticsService, IParamasGetInquiryAnalitic } from "../../services/dashboard/getInquiryAnalytics.service";
import AppGetIcon from "../../../../common/UI/AppGetIcon";
import Loading from "../../../../common/UI/Loading";
import InputSearch from "../../../../common/UI/DataTable/inputSearch";
import { GetInquiryAnalyticsByDateService } from "../../services/dashboard/getInquiryAnalyticsByDate.service";

interface ChannelCount {
  channelName: string;
  counts: number[];
}

interface InquiryAnalyticsResponse {
  dates: string[];
  channelCounts: ChannelCount[];
}


export default function DashboardPage() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );
  const hFormatDate = useFormattedDate();
  const today = new Date();

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<any>(today);
  const [endDate, setEndDate] = useState<any>(today); // Inicia como null para evitar llamadas innecesarias
  const [startDateAnalytics, setStartDateAnalytics] = useState<any>(today);
  const [endDateAnalytics, setEndDateAnalytics] = useState<any>(today); // Inicia como null para evitar llamadas innecesarias
  const [startDateInquiry, setStartDateInquiry] = useState<any>(today);
  const [endDateInquiry, setEndDateInquiry] = useState<any>(today); // Inicia como null para evitar llamadas innecesarias
  const [startDateSession, setStartDateSession] = useState<any>(today);
  const [endDateSession, setEndDateSession] = useState<any>(today); // Inicia como null para evitar llamadas innecesarias
  const [inquiryAveragesAnalyticsData, setInquiryAveragesAnalyticsData] = useState<InquiryAveragesAnalyticsResponseDto[]>([]);
  const [inquiryAnalyticsData, setInquiryAnalyticsData] = useState<IParamasGetInquiryAnalitic[]>([]);
  const [countTypeSelect, setCountTypeSelect] = useState<any>({label: 'En sesion', value: 'session'});
  const [responseDataGraphSession, setResponseDataGraphSession] = useState<InquiryAnalyticsResponse | null>(null);
const [responseDataGraphInquiry, setResponseDataGraphInquiry] = useState<InquiryAnalyticsResponse | null>(null);

  const [dataGraphSession, setDataGraphSession] = useState<any[]>([]);
  const [dataGraphInquiry, setDataGraphInquiry] = useState<any[]>([]);
  const [dataGraphoptionsSession, setDataGraphoptionsSession] = useState<any>({});
  const [dataGraphoptionsInquiry, setDataGraphoptionsInquiry] = useState<any>({});

  const getOptionsCountType = () => {
		return [
			{ label: 'En sesion', value: 'internal' },
			{ label: 'inquiry', value: 'inquiry' },
		];
	};
  const getChannelIcon = (channelName: string) => {
    switch (channelName) {
      case "WhatsApp":
        return "whatsapp";
      case "Messenger":
        return "mesenger";
      case "Web":
        return "chrome";
      case "App":
        return "appLaptop";
      default:
        return "";
    }
  };


  const getDataInquiryAveragesAnalytics = async () => {
    setLoading(true);
    const params: IParamasGetInquiry = {
      startDate: startDate ? hFormatDate(startDate, "yyyy-MM-dd") : "",
      endDate: endDate ? hFormatDate(endDate, "yyyy-MM-dd") : "",
    };

    try {
      const response = await GetInquiryAveragesAnalyticsService(params);
      setInquiryAveragesAnalyticsData(response?.channelAverage || []);
    } catch (error) {
      console.error("Error fetching inquiry averages analytics:", error);
    }
    setLoading(false);
  };

  const getDataInquiryAnalyticSession = useCallback(async () => {
    setLoading(true);
    const params: IParamasGetInquiryAnalitic = {
      startDate: startDateSession ? hFormatDate(startDateSession, "yyyy-MM-dd") : "",
      endDate: endDateSession ? hFormatDate(endDateSession, "yyyy-MM-dd") : "",
      countType: 'session',
    };
  
    try {
      const response = await GetInquiryAnalyticsByDateService(params);
      if (response) {
        setResponseDataGraphSession(response as InquiryAnalyticsResponse);
      } else {
        console.warn("No data received for session analytics.");
        setResponseDataGraphSession(null);
      }
    } catch (error) {
      console.error("Error fetching inquiry averages analytics:", error);
      setResponseDataGraphSession(null);
    } finally {
      setLoading(false);
    }
  }, [endDateSession]);
  
  const getDataInquiryAnalyticsInquiry = useCallback(async () => {
    setLoading(true);
    const params: IParamasGetInquiryAnalitic = {
      startDate: startDateInquiry ? hFormatDate(startDateInquiry, "yyyy-MM-dd") : "",
      endDate: endDateInquiry ? hFormatDate(endDateInquiry, "yyyy-MM-dd") : "",
      countType: 'inquiry',
    };
  
    try {
      const response = await GetInquiryAnalyticsByDateService(params);
      if (response) {
        setResponseDataGraphInquiry(response as InquiryAnalyticsResponse);
      } else {
        console.warn("No data received for inquiry analytics.");
        setResponseDataGraphInquiry(null);
      }
    } catch (error) {
      console.error("Error fetching inquiry averages analytics:", error);
      setResponseDataGraphInquiry(null);
    } finally {
      setLoading(false);
    }
  }, [endDateInquiry]);
  
  const getDataInquiryAnalytics = async () => {
    setLoading(true);
    const params: IParamasGetInquiryAnalitic = {
      startDate: startDateAnalytics ? hFormatDate(startDateAnalytics, "yyyy-MM-dd") : "",
      endDate: endDateAnalytics ? hFormatDate(endDateAnalytics, "yyyy-MM-dd") : "",
      countType: countTypeSelect.value
    };

    try {
      const response = await GetInquiryAnalyticsService(params);
      setInquiryAnalyticsData(response?.channelCount || []);
    } catch (error) {
      console.error("Error fetching inquiry averages analytics:", error);
    }
    setLoading(false);
  };


  useEffect(() => {
    if (endDate) {
      // Llamar a los servicios solo si hay una fecha de fin seleccionada
      getDataInquiryAveragesAnalytics();
    }
  }, [endDate]); // Se activa solo cuando cambia `endDate`

  useEffect(() => {
    if (startDateInquiry && endDateInquiry) {
    getDataInquiryAnalyticsInquiry();
    }
  }, [startDateInquiry, endDateInquiry]);

  useEffect(() => {
    if (startDateSession && endDateSession) {
      getDataInquiryAnalyticSession();
    }
  }, [startDateSession, endDateSession]);

  useEffect(() => {
    if (endDateAnalytics) {
      // Llamar a los servicios solo si hay una fecha de fin seleccionada
      getDataInquiryAnalytics();
    }
  }, [endDateAnalytics,countTypeSelect]); // Se activa solo cuando cambia `endDate`

  useEffect(() => {
    headerStore.setModule("Administración", "");
    headerStore.setModuleItem("Dashboard", "/admin/home");

  }, []);


useEffect(() => {
  if (responseDataGraphSession) {
    const formattedDates = responseDataGraphSession.dates.map((date: string) =>
    hFormatDate(date, "dd-MM-yyyy")

    );

    const channelData = responseDataGraphSession.channelCounts.map((channel: ChannelCount) => ({
      name: channel.channelName,
      data: channel.counts.map(count => Number(count) || 0),
    }));

    const numSeries = channelData.length;

    setDataGraphSession(channelData);

    setDataGraphoptionsSession({
      chart: {
        type: "area",
        height: 350,
        zoom: { enabled: true, type: "x", autoScaleYaxis: true },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
          },
          autoSelected: "zoom",
        },
      },
      theme: { palette: "palette8" },
      stroke: {
        curve: "straight",
        width: Array(numSeries).fill(3),
        dashArray: Array(numSeries).fill(0),
      },
      markers: {
        size: 5,
        hover: { sizeOffset: 3 },
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => val.toString(),
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -60,
          style: { fontSize: "10px" },
        },
        title: { style: { fontSize: "12px" } },
      },
      yaxis: {
        min: 0,
        decimalsInFloat: 0,
        labels: {
          formatter: (val?: number) => (val != null ? val.toFixed(0) : '0'),
          style: { fontSize: '12px' },
        },
        forceNiceScale: false,
        title: { style: { fontSize: "12px" } },
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        formatter: (_: string, opts: { seriesIndex: number }) =>
          channelData[opts.seriesIndex]?.name ?? "Canal",
      }

    });
  }
}, [responseDataGraphSession]);
  
useEffect(() => {
  if (responseDataGraphInquiry) {
    const formattedDates = responseDataGraphInquiry.dates.map((date: string) =>
          hFormatDate(date, "dd-MM-yyyy")

    );

    const channelData = responseDataGraphInquiry.channelCounts.map((channel: ChannelCount) => ({
      name: channel.channelName,
      data: channel.counts.map(count => Number(count) || 0),
    }));

    const numSeries = channelData.length;

    setDataGraphInquiry(channelData);

    setDataGraphoptionsInquiry({
      chart: {
        type: "area",
        height: 350,
        zoom: { enabled: true, type: "x", autoScaleYaxis: true },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
          },
          autoSelected: "zoom",
        },
      },
      theme: { palette: "palette5" },
      stroke: {
        curve: "straight",
        width: Array(numSeries).fill(3),
        dashArray: Array(numSeries).fill(0),
      },
      markers: {
        size: 5,
        hover: { sizeOffset: 3 },
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => val.toString(),
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -60,
          style: { fontSize: "10px" },
        },
        title: { style: { fontSize: "12px" } },
      },
      yaxis: {
        min: 0,
        decimalsInFloat: 0,
        labels: {
          formatter: (val?: number) => (val != null ? val.toFixed(0) : '0'),
          style: { fontSize: '12px' },
        },
        title: { style: { fontSize: "12px" } },
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        formatter: (_: string, opts: { seriesIndex: number }) =>
          channelData[opts.seriesIndex]?.name ?? "Canal",
      }

    });
  }
}, [responseDataGraphInquiry]);




  return (
    <div className={style.Dashboard_page}>
      <h4 className={style.under__line}>
        <strong>Análisis de Canales y Consultas - Dashboard:</strong>
      </h4>
  
      {/* Muestra el componente Loading siempre */}
      {loading && <ProgressBar />}
  
      {/* Filtros de Fecha */}
      <div className={style.containerRols}>
        {/* PRIMERA CARDS */}
        <div className={style.dashboardContainer}>
          <h4 className={style.under__line}>
            <strong>Cantidad de consultas por canal:</strong>
          </h4>
          <div
            className={style.Card__filters_head}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <DateInput
              name="fecha"
              textLabel="Seleccionar rango fechas"
              classNameInput={styleForm.input__input}
              initialValue={[startDate, endDate]}
              range={true}
              dateFormat="dd-MM-yyyy"
              onChange={(dateSelected: any) => {
                setStartDate(dateSelected[0]);
                setEndDate(dateSelected[1]);
              }}
            />
          </div>
          <div className={style.containerRols}>
            {inquiryAveragesAnalyticsData.map((item: any, index: number) => {
              const icon = getChannelIcon(item.channelName);
              return (
                <CardDashboard
                  key={index}
                  description={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexDirection: "column",
                      }}
                    >
                      <AppGetIcon
                        name={icon}
                        style={{ width: "55px", height: "55px" }}
                      />
                      <span className={style.cardDashboardDescription}> {`Porcentaje ${item.average}%`}</span>
                    </div>
                  }
                />
              );
            })}
          </div>
        </div>
  
        {/* CARDS Gráficos */}
        <div className={style.containerGraph} style={{ marginTop: "0.5rem" }}>
          <ChartComponent
            typeGraph="bar"
            dataDashboard={dataGraphSession}
            dataOptions={dataGraphoptionsSession}
            onDateChange={(dateRange) => {
              if (dateRange) {
                setStartDateSession(dateRange[0]);
                setEndDateSession(dateRange[1]);
              }
            }}
            titleChart="Sesiones por Canal"
          />

          <ChartComponent
            typeGraph="bar"
            dataDashboard={dataGraphInquiry}
            dataOptions={dataGraphoptionsInquiry}
            onDateChange={(dateRange) => {
              if (dateRange) {
                setStartDateInquiry(dateRange[0]);
                setEndDateInquiry(dateRange[1]);
              }
            }}
            titleChart="Consultas por Canal"
          />
        </div>
  
        {/* SEGUNDA CARDS */}
        <div className={style.dashboardContainer}>
          <h4 className={style.under__line}>
            <strong>Cantidad de porcentaje por canal:</strong>
          </h4>
          <div
            className={style.Card__filters_head}
          >
            <DateInput
              name="fecha"
              textLabel="Seleccionar rango fechas"
              classNameInput={styleForm.input__input}
              initialValue={[startDateAnalytics, endDateAnalytics]}
              range={true}
              dateFormat="dd-MM-yyyy"
              onChange={(dateSelected: any) => {
                setStartDateAnalytics(dateSelected[0]);
                setEndDateAnalytics(dateSelected[1]);
              }}
            />
            <InputSearch
              key={Math.random()}
              name="countType"
              classNameInput={styleForm.input__input}
              textLabel="Selecciona tipo"
              data={getOptionsCountType()}
              onSelect={(selected) => {
                setCountTypeSelect(selected);
              }}
              selected={countTypeSelect}
            />
          </div>
          <div className={style.containerRols}>
            {inquiryAnalyticsData.map((item: any, index: number) => {
              const icon = getChannelIcon(item.channelName);
              return (
                <CardDashboard
                  key={index}
                  description={
                    <div
                    className={style.cardDashboardContent}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexDirection: "column",
                      }}
                    >
                      <AppGetIcon
                        name={icon}
                        style={{ width: "55px", height: "55px" }}
                      />
                      <span className={style.cardDashboardDescription}>{`Total ${item.count}`}</span>
                    </div>
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );  

}
